

export enum KalturaCaptionAssetStatus {
    deleted=3,
	error=-1,
	exporting=9,
	importing=7,
	queued=0,
	ready=2
}